import { render } from "./ProductsPage.vue?vue&type=template&id=2a8b3bf8&scoped=true"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"

import "./ProductsPage.vue?vue&type=style&index=0&id=2a8b3bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8b3bf8"]])

export default __exports__